import getInstanceAxios from '../Request';

export default getInstanceAxios(process.env.REACT_APP_BOOKING_MSA_DOMAIN);
